import { styled } from "@styles";
import { InfoCircle } from "@untitled-ui/icons-react";

export const Header = styled("div", {
  display: "flex",
  width: "100%",
  alignItems: "center",
  gap: "$16px",
  marginBottom: "$24px",
});

export const InfoIcon = styled(InfoCircle, {
  path: {
    fill: "$blue50",
  },
});

export const Rule = styled("p", {
  color: "$neutral60",
  fontSize: "$16px",
  lineHeight: "$24px",
  fontWeight: "$regular",
  margin: "0",
  marginLeft: "$16px",
});
